import cn from 'classnames';

import { defineTheme, type ThemeKeys } from 'js/utils/theme-helpers';

import RichText from 'components/rich-text/RichText';

import { IRichTextBlock } from 'source/NFR.types';

const themes = defineTheme({
  noPadding: 'rich-text-block--theme-no-padding'
});

type Theme = ThemeKeys<typeof themes>;

interface RichTextBlockProps extends IRichTextBlock {
  theme?: Theme | Theme[];
}

const RichTextBlock: React.FC<RichTextBlockProps> = ({ text, theme }) => (
  <div className={cn('rich-text-block', themes(theme))}>
    <RichText {...text} />
  </div>
);

RichTextBlock.displayName = 'RichTextBlock';

export default RichTextBlock;
